// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";

import MultiSelect from "./MultiSelect";
import ChatroomName from "./Name";

type Props = {
  value: Array<number>,
  multiple: boolean,
  handleClose: Function,
};

const Conversation = ({ value, multiple, handleClose }: Props) => {
  if ((value || []).length === 0) {
    return (
      <div>
        <i>{i18n.t(k.NO_VALUE)}</i>
      </div>
    );
  }

  if (multiple && value) {
    return <MultiSelect value={value} handleClose={handleClose} />;
  }

  return (
    <div>
      <ChatroomName id={value[0]} handleClose={handleClose} />{" "}
    </div>
  );
};

export default Conversation;
